var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"round-remove-button"},_vm.$listeners),[_c('img',{attrs:{"src":require('@/assets/onboarding/icons/icon-remove.svg'),"width":_vm.width,"height":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }